/**
 * @module App
 * @author Charles Blais <charles.blais@canada.ca>
 */
import './App.css';

import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import queryString from 'query-string';

import BookContainer from './containers/BookContainer';
import StationContainer from './containers/StationContainer';
import UserFeedback from './components/UserFeedback';

import useNetworksWebService from './hooks/useNetworksWebService';
import { useAppState } from './contexts/AppStateProvider';

const App = ({
  defaultNetwork
}) => {
  const { url, isLoading, isError, networks, setUrl } = useNetworksWebService();
  const [ state ] = useAppState();

  // Only when the networks have updated the we extract and set the station state
  useEffect(() => {
    const {network, station, starttime, endtime} = queryString.parse(window.location.search);
    const searchNetwork = !(network)?defaultNetwork:network;
    const level = (station) ? 'channel' : null;
    setUrl(`${state.fdsnws}?${queryString.stringify({
      network: searchNetwork, station, starttime, endtime, level})}`);
  }, [defaultNetwork, state.fdsnws, setUrl]);

  // the type of station display is determined by the content of the networks object
  // if we have a single station, then its detailed display
  const container = ( networks.length === 1 && networks[0].stations.length >= 1 ) ? (
    <StationContainer
      networkCode={networks[0].code}
      station={networks[0].stations[0]}
      fdsnws={url}
    />
  ): (
    <BookContainer
      networks={networks}
    />
  );

  return (
    <>
      <UserFeedback isLoading={isLoading} isError={isError} />
      { (!isLoading && !isError) && container }
    </>
  );
}

App.propTypes = {
  defaultNetwork: PropTypes.string,
};


App.defaultProps = {
  defaultNetwork: null,
};

export default App;
